<template>
    <a v-if="fileDownloadUrl" class="text-dense" :href="fileDownloadUrl" target="_blank">
        {{ fileName }}
    </a>
    <span v-else>{{ displayValue }}</span>
</template>

<script>
import {fileuploadApi} from "@/common/api/fileuploadApi";

export default {
    computed: {
    	fileName() {
    		return this.params.fileNameField
				? this.params.data[this.params.fileNameField] // custom name
				: this.params.data[this.params.colDef.field]; // name defined by the actual file
		},
		fileId() {
			return this.params.data[this.params.fileIdField];
		},
        fileDownloadUrl() {
            return this.params.downloadUrlField
				? this.params.data[this.params.downloadUrlField] // custom download url
				: this.fileId
					? fileuploadApi.getPdfUrl(this.fileId) // normal download url by file id
					: null; // no download link
        },
    	displayValue() {
    		return this.params.value || this.fileName;
		}
    }
};
</script>